import type { OrderTab } from '@src/orders/domain/OrderTab';
import { OrdersClient } from '@src/orders/services/OrdersClient';
import { useMutation } from '@tanstack/react-query';

export interface OrderPagination {
  page: number;
  tab: OrderTab;
}

interface Filters {
  assignedToMe: boolean;
  orderId: string;
  pageSize: number;
}

export const useGetOrderPagination = () => {
  const { mutateAsync: getOrderPagination } = useMutation<
    OrderPagination,
    Error,
    Filters
  >({
    mutationFn: (data: Filters) =>
      OrdersClient.findPaginationForOrder({
        ...data,
        limit: data.pageSize,
      }),
  });

  return {
    getOrderPagination,
  };
};
